import type { FieldProps } from '@rjsf/utils';
import { forwardRef } from 'react';
import SwitchWidget from '../widgets/SwitchWidget';

/**
 * Switch field for boolean on/off fields
 * Wraps SwitchWidget to provide field interface
 */
const SwitchField = forwardRef<HTMLDivElement, FieldProps<boolean>>((props, ref) => {
  const {
    formData,
    onChange,
    schema,
    onFocus,
    onBlur,
    disabled,
    readonly,
    fieldPathId: { path },
    name,
    registry,
    options,
  } = props;

  const id = path.join('.');

  // Adapt FieldProps to WidgetProps - SwitchWidget only uses the destructured props
  // but TypeScript requires all WidgetProps, so we provide them all
  return (
    <div ref={ref}>
      <SwitchWidget
        {...{
          value: formData,
          onChange: (checked: boolean) => onChange(checked, path),
          id,
          disabled,
          readonly,
          label: schema.title,
          schema,
          onFocus,
          onBlur,
          name,
          registry,
          options,
        }}
      />
    </div>
  );
});

SwitchField.displayName = 'SwitchField';

export default SwitchField;
